import React from 'react';
import styled from 'styled-components';
import RefinancePlan from './RefinancePlan';
import MobilPlan from './MobilPlan';
import { Link, navigate } from '@reach/router';
import handShake from '../../icons/handShake.png';
import blur from '../../icons/blur.jpg';

export default function Refinancing() {
  return (
    <PageWrapper>
      <h1>Refinancování</h1>
      <RefinancePlan />
      <MobilPlan />
      <LoansContainer>
        <Box onClick={() => navigate('/objednatkrefinancovani')}>
          <h3>Domluvit schůzku</h3>
          <Link to='/objednatkrefinancovani'>
            <Text>
              <p>Objednejte se</p>
            </Text>
          </Link>
          <MoneyPic src={handShake} />
        </Box>
        <TextContainer>
          <h2>Obvyklý účel úvěru:</h2>
          <ul>
            <li>Refinancování dříve provedené rekonstrukce</li>
            <li>Refinancování úvěru na koupi objektu</li>
          </ul>
        </TextContainer>
      </LoansContainer>
    </PageWrapper>
  );
}

const MoneyPic = styled.img`
  width: 100%;
  border-radius: 0 0 15px 15px;
  margin-bottom: -1px;
  background: url(${blur});
  background-repeat: no-repeat;
  background-size: cover;
`;
const Text = styled.div`
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translate(-50%,0);
  background: rgba(255,0,0, .6);
  padding: 0 12px;

  p {
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.common.black};
    font-weight: 600;
  }
`;
const Box = styled.div`
  width: 100%;
  max-width: 320px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  margin: 0 36px;
  position: relative;
  transition: all .6s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: scale(1.1);
    @media(max-width: 900px) {
      transform: scale(1);
    }
  }
  @media(max-width: 900px) {
    margin: 24px 0;
  }

`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  li {margin: 0 12px; padding-right: 48px;}
  h3 {text-align: left !important;}

`;
const LoansContainer = styled.div`
  display: flex;
  justify-content:center;
  padding: 24px 0;
  @media(max-width: 900px) {
    flex-direction: column-reverse;
    align-items: center;
    h3 {text-align: center !important;}
  }
`;
const PageWrapper = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;

  h3 { text-align: center; }
`;
